import React from 'react';

interface Props {
  title: React.ReactNode;
}

const ListFlowPanel: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
}) => {
  return (
    <div className="mb-4 rounded border px-4 py-3">
      <label className="flex justify-between text-base font-semibold">
        {title}
      </label>

      {children}
    </div>
  );
};

export default ListFlowPanel;
